const inits = {
  id: [],
  filterSlug: '',
  label: null,
  location: false,
  viewLevel: 0
}

const FilteredReducer = (s = inits, action) => {
  const {payload} = action
  switch (action.type) {
    case '_FILTERED':
      return { ...s, [payload[0]]: payload[1] }

    default:
      return s;
  }
};
export default FilteredReducer
